import { useNavigate } from '@tanstack/react-router';
import { Button } from '@/components/Button';
import { MdKeyboardArrowLeft } from 'react-icons/md';
import LinkedAccountSelectService from '../components/LinkedAccountSelectService';
import { isGroupSourceType } from '../utils/serviceGroup';

export default function LinkedAccountNewTemplate() {
  const navigate = useNavigate();

  return (
    <div className="flex flex-col gap-6 px-6 py-3">
      <div className="flex items-center justify-between">
        <h1 className="text-heading-md">追加したいアカウントを選択</h1>
        <Button
          type="button"
          color="secondary"
          onClick={() => navigate({ to: '/agent/linked_accounts' })}
        >
          <MdKeyboardArrowLeft size={20} />
          連携先一覧へ戻る
        </Button>
      </div>
      <div className="flex justify-center">
        <LinkedAccountSelectService
          onServiceSelect={(service) => {
            const sourceType = service.sourceType ?? '';
            if (isGroupSourceType(sourceType)) {
              navigate({
                to: '/agent/linked_accounts/new/group/$groupKey',
                params: { groupKey: sourceType },
              });
              return;
            }
            navigate({
              to: '/agent/linked_accounts/new/$sourceType',
              params: { sourceType },
            });
          }}
        />
      </div>
    </div>
  );
}
